import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../constants/routes'


import AdminInstallationView from './view'
import AdminInstallationList from './list'

const AdminInstallationIndex = () => {
    return (
        <>
            <div className="builder-view">
                <Routes>
                    <Route path={nestedRoutePath(routes.adminInstallationIndex.path, routes.adminInstallationView.path)} element={<AdminInstallationView />} />
                    <Route index element={<AdminInstallationList />} />
                </Routes>
            </div>
        </>
    )
}

export default AdminInstallationIndex
